import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-challenge-select',
  templateUrl: './challenge-select.component.html',
  styleUrls: ['./challenge-select.component.css']
})
export class ChallengeSelectComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/ericzayas/Documents/relativePitch/src/app/components/challenge-select/challenge-select.component.ts